import Button, { EButtonColor, EButtonVariant } from "components/elements/Button";
import { TrashIcon } from "@heroicons/react/24/solid";
import classes from "./classes.module.scss";
import { container } from "tsyringe";
import CommentService from "services/projects/CommentService";
import { useCallback, useEffect, useState } from "react";
import { useProjectId } from "hooks/useProjectId";
import { usePostId } from "hooks/usePostId";
import CommentResponseResource from "common/resources/Project/Config/Forum/Comment/CommentResponseResource";

const commentService = container.resolve(CommentService);

type IProps = {
	comment: Pick<CommentResponseResource, "id">;
	onDeleted: (comment: Pick<CommentResponseResource, "id">) => void;
};

export default function CommentDeleteButton(props: IProps) {
	const { canDelete, deleteComment } = useDeleteComment(props.comment);

	const onClick = useCallback(() => {
		deleteComment().then(() => props.onDeleted(props.comment));
	}, [deleteComment, props]);

	if (!canDelete) return null;
	return <Button onClick={onClick} startIcon={<TrashIcon />} className={classes["icon"]} variant={EButtonVariant.OUTLINED} color={EButtonColor.DESTRUCTIVE} />;
}

const useDeleteComment = (comment: Pick<CommentResponseResource, "id">) => {
	const { projectId } = useProjectId();
	const { postId } = usePostId();
	const [canDelete, setCanDelete] = useState(false);

	const fetchCanDelete = useCallback(() => {
		return commentService.canDelete(projectId, postId, comment.id).then(setCanDelete);
	}, [comment.id, postId, projectId]);

	const deleteComment = useCallback(() => {
		return commentService.delete(projectId, postId, comment.id);
	}, [projectId, postId, comment]);

	useEffect(() => {
		fetchCanDelete();
	}, [fetchCanDelete]);

	return {
		canDelete,
		deleteComment,
	};
};
